export default class FuelDiscountBalanceResponse {
    constructor (json) {
        this._rewardDetails = json.rewardDetails
    }

    getProperty (name) {
        return this.json[name]
    }

    toObj () {
        return this.json
    }

    redeemableRewards () {
        return this._rewardDetails.redeemableRewards
    }
}

// {
//     "responseCode": "SUCCESS",
//     "rewardDetails": {
//         "redeemableRewards": "0.00",
//         "rewardExpirationAmount": "0.00",
//         "rewardExpirationDate": "2029-01-01 23:59:59",
//         "totalRewards": "0.00",
//         "unRedeemableRewards": "0.00",
//         "rewardsByParticipant": [],
//         "lifeTimeSavings": "0.00",
//         "includedRewardTypes": [],
//         "rewardType": "CPG"
//     }
// }



// WEBPACK FOOTER //
// ./src/models/responses/FuelDiscountBalanceResponse.js